import { render, staticRenderFns } from "./RoomSelector.vue?vue&type=template&id=04933a96&"
import script from "./RoomSelector.vue?vue&type=script&setup=true&lang=js&"
export * from "./RoomSelector.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports